import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { mediaActions } from '../actions'
import Spinner from 'srcReact/components/common2/Spinner'
import NotFound from 'srcReact/components/common2/NotFound'
import SearchTextBox from 'srcReact/components/common2/SearchTextBox'
import FilterTabs from 'srcReact/components/common2/FilterTabs'
import DocumentPreview from 'srcReact/MessengerPage/components/DocumentPreview'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import parentStyles from '../styles.module.scss'
import styles from './styles.module.scss'

function DocumentList({ type, id, noDatatitle, handleDelete, deleteFileLoading, isStatic }) {
  const { t } = useTranslation()

  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })
  const [search, setSearch] = useState('')
  const [filter, setFilter] = useState('all')
  const dispatch = useDispatch()

  const {
    login: { user: loggedInUser },
    common: { isNative, isMobile },
    media: { documents }
  } = useSelector((state) => state)

  useEffect(() => {
    console.log(filter)
    if (!isStatic) {
      dispatch(mediaActions.getDocuments(type, id, pagination, search, filter))
    }
  }, [pagination, search, filter])

  const lastDocumentRef = useInfinitScroll(
    documents.loading,
    documents.stats && documents.stats.remaining,
    documents.stats && documents.stats.next_offset,
    setPagination,
    [documents.loading]
  )

  const handleSearch = (text) => {
    setSearch(text)
  }

  return (
    <React.Fragment>
      <div className={parentStyles.actions}>
        <SearchTextBox
          placeholder={isMobile ? t('global.search') : t('formlabel.searchDocumentPlaceholder')}
          handleSearch={handleSearch}
          minimumSearchChar={2}
        />
        <FilterTabs
          className={styles.filterTabsContainer}
          tabs={[
            {
              display: t('global.all'),
              selected: filter === 'all',
              show: true,
              onClick: () => setFilter('all')
            },
            {
              display: t('global.pdf'),
              selected: filter === 'pdf',
              show: true,
              onClick: () => setFilter('pdf')
            },
            {
              display: t('global.docx'),
              selected: filter === 'doc',
              show: true,
              onClick: () => setFilter('doc')
            },
            {
              display: t('global.xls'),
              selected: filter === 'xls',
              show: true,
              onClick: () => setFilter('xls')
            },
            {
              display: t('global.others'),
              selected: filter === 'others',
              show: true,
              onClick: () => setFilter('others')
            }
          ]}
        />
      </div>
      {!documents.loading && documents.list && documents.list.length === 0 ? (
        <NotFound title={noDatatitle} className={styles.notFoundWrapper} />
      ) : (
        <div className={styles.documentsList}>
          {documents.list.map((document, index) => {
            const isLast = documents.list.length === index + 1
            const fileName = document.name
            const extension = fileName && fileName.split('.').pop().toLowerCase()
            return (
              <DocumentPreview
                lastRef={isLast ? lastDocumentRef : null}
                key={`doc${index}${document.id}`}
                showOpened={true}
                fileSize={document.original_file_size}
                showOptions={true}
                showDelete={document.is_from_newsfeed !== 1}
                fileName={fileName}
                extension={extension}
                path={document.url}
                className={styles.document}
                documentNameCSS={styles.documentName}
                handleDelete={() => handleDelete(document.id)}
                isNative={isNative}
                deleteFileLoading={deleteFileLoading}
                isCreator={loggedInUser.id == document.user_id}
                mimeType={document.mime_type}
                isOriginal={document.is_original}
                originalTag={document.original_tag}
                documentId={document.id}
                linkUrl={document.link_url}
              />
            )
          })}
        </div>
      )}
      {documents.loading && <Spinner />}
    </React.Fragment>
  )
}

export default DocumentList
